
import React from 'react';
import { CommandGroup, CommandSeparator } from "@/components/ui/command";
import CustomerItem from './CustomerItem';
import CustomerLoading from './CustomerLoading';
import { Customer, CustomerStats } from './types';

interface CustomerListProps {
  customers: Customer[];
  selectedCustomerId?: string;
  onSelectCustomer: (id: string, name: string) => void;
  loadingStats: boolean;
  canEdit?: boolean;
  onEditCustomer?: (customerId: string) => void;
}

const CustomerList = ({ 
  customers, 
  selectedCustomerId, 
  onSelectCustomer,
  loadingStats,
  canEdit = false,
  onEditCustomer
}: CustomerListProps) => {
  return (
    <CommandGroup>
      {loadingStats && <CustomerLoading message="Chargement des statistiques..." small />}
      
      {customers.map((customer) => (
        <CustomerItem 
          key={customer.id}
          customer={customer} 
          selectedCustomerId={selectedCustomerId}
          onSelect={onSelectCustomer}
          canEdit={canEdit}
          onEditCustomer={onEditCustomer}
        />
      ))}
      
      {!customers.length && (
        <div className="py-6 text-center text-sm text-muted-foreground">
          Aucun client trouvé
        </div>
      )}
    </CommandGroup>
  );
};

export default CustomerList;
